import videojs from 'video.js';

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

(function () {
  const Component = videojs.getComponent('Component');

  class ThumbnailPreview extends Component {
    _frequency = 0;
    _width: number;
    _height: number;
    _count: number;
    _duration: number;
    _img: HTMLImageElement;

    constructor(player, options) {
      super(player, options);
    }

    createEl() {
      const options = this.options_;
      const el = videojs.dom.createEl('div', {
        className: 'vjs-thumbnail-preview',
      }) as HTMLDivElement;
      el.style.opacity = '0';

      const container = document.createElement('div');
      container.classList.add('vjs-thumbnail-preview-container');

      const ratio = 16 / 9;

      this._img = document.createElement('img');
      this._img.classList.add('vjs-thumbnail-preview-img');
      this._img.src = options?.slideImage;

      this._img.onload = () => {
        const width = this._img.naturalWidth;
        const height = width / ratio;
        this._count = this._img.naturalHeight / height;
      };

      container.append(this._img);

      el.append(container);

      this.player().on('play', () => {
        const { width, height } = el.getBoundingClientRect();
        this._width = width;
        this._height = height;

        window.addEventListener('resize', () => {
          const { width, height } = el.getBoundingClientRect();
          this._width = width;
          this._height = height;
          //

          const imgWidth = this._img.naturalWidth;
          const imgHeight = imgWidth / ratio;
          this._count = this._img.naturalHeight / imgHeight;
        });

        const controlBar = this.player().getChild('ControlBar');
        const seekBar = controlBar
          .getChild('ProgressControl')
          .getChild('SeekBar');

        const seekBarEl = seekBar.el();

        this._duration = this.player().duration();

        controlBar.getChild('ProgressControl').getChild('SeekBar');

        const updateThumbnail = (clientX) => {
          requestAnimationFrame(() => {
            if (!this._duration) {
              this._duration = this.player().duration();
            }

            // in seconds
            this._frequency = this._duration / this._count;

            const { x: barX, width: barWidth } =
              seekBarEl.getBoundingClientRect();

            el.style.opacity = '1';
            if (!isTouchDevice()) {
              el.style.left = `${Math.min(Math.max(50, clientX - barX), barWidth - 50)}px`;
            }

            const position = (clientX - barX) / barWidth;
            const time = this._duration * position;
            const index = Math.floor(time / this._frequency);

            this._img.style.top = `${-index * this._height}px`;
          });
        };

        seekBar.on('mousemove', (e: MouseEvent) => {
          updateThumbnail(e.clientX);
        });

        seekBar.on('mouseleave', () => {
          el.style.opacity = '0';
        });

        seekBar.on('touchmove', (e: TouchEvent) => {
          updateThumbnail(e.touches[0].clientX);
        });

        seekBar.on('touchend', () => {
          el.style.opacity = '0';
        });
      });

      return el;
    }
  }

  videojs.registerComponent('ThumbnailPreview', ThumbnailPreview);
})();
